const baseURL = process.env.REACT_APP_PLATFORM_API_BASE_URL;

/**
 * Retrieve OCR result by ID
 * @param {string} resultId - The OCR result ID
 * @param {string} inviteId - The invite/session ID
 * @param {string} accessToken - JWT access token
 * @param {string} idToken - OpenID token
 * @returns {Promise<{success: boolean, result: Object}>}
 */
export const getOcrResult = async (resultId, inviteId, accessToken, idToken) => {
  const url = `${baseURL}/api/ocr/result/${resultId}?inviteId=${inviteId}`;
  const res = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: "Bearer " + accessToken,
      "X-OpenID": idToken,
    },
  });
  const data = await res.json();
  return data;
};

/**
 * Submit user feedback (thumbs up/down) for OCR results
 * @param {string} resultId - The OCR result ID
 * @param {string} inviteId - The invite/session ID
 * @param {string} rating - Either 'up' or 'down'
 * @param {string} userId - The user ID submitting feedback
 * @param {string} accessToken - JWT access token
 * @param {string} idToken - OpenID token
 * @returns {Promise<{success: boolean, message?: string}>}
 */
export const submitFeedback = async (
  resultId,
  inviteId,
  rating,
  userId,
  accessToken,
  idToken
) => {
  const url = `${baseURL}/api/ocr/feedback`;
  const requestBody = {
    resultId,
    inviteId,
    rating,
    userId,
  };
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: "Bearer " + accessToken,
      "X-OpenID": idToken,
    },
    body: JSON.stringify(requestBody),
  });
  const data = await res.json();
  return data;
};

/**
 * Submit user corrections to OCR results
 * @param {string} resultId - The OCR result ID
 * @param {string} inviteId - The invite/session ID
 * @param {Object} correctedData - The corrected data object
 * @param {string} comments - Comments explaining the corrections
 * @param {string} accessToken - JWT access token
 * @param {string} idToken - OpenID token
 * @returns {Promise<{success: boolean, message?: string}>}
 */
export const submitCorrection = async (
  resultId,
  inviteId,
  correctedData,
  comments,
  accessToken,
  idToken
) => {
  const url = `${baseURL}/api/ocr/correction`;
  const requestBody = {
    resultId,
    inviteId,
    correctedData,
    comments,
  };
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: "Bearer " + accessToken,
      "X-OpenID": idToken,
    },
    body: JSON.stringify(requestBody),
  });
  const data = await res.json();
  return data;
};
